import { Component, OnInit, inject } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators,AbstractControl } from '@angular/forms';
import { FormGroupControls } from '../../common/form-controls';
import { NeedHelpService } from '../../service/common/need-help.service';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { utilGet } from '../../service/library/library';
import { UserDetailService } from '../../service/common/user/user-detail.service';
import { UserLoggedInInfo } from '../../model/engage/user-detail';

@Component({
    selector: 'dd-need-help',
    templateUrl: './need-help.component.html',
    styleUrls: ['./need-help.component.scss'],
    standalone: false
})
export class NeedHelpComponent implements OnInit {

  eop: string[] = ['Email', 'Phone Number'];

  public emailRegex = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/;
  needHelpForm = new UntypedFormGroup({
    contactThrough: new UntypedFormControl('Email'),
    name: new UntypedFormControl('', [Validators.required, Validators.pattern(/^[a-zA-Z]+(?:\s[a-zA-Z]+)*$/)]),
    problem: new UntypedFormControl('', [Validators.required, Validators.pattern(/^[a-zA-Z0-9\s]+$/)]),
    reviewNumber: new UntypedFormControl('', [Validators.pattern(/^[A-Za-z0-9]+$/)]),
    email: new UntypedFormControl('', [Validators.pattern(this.emailRegex)]),
    phoneNumber: new UntypedFormControl('', [Validators.pattern(/^\d{10}$/)]),
  });
  public showWarning: string;
  public showSuccessContent = false;

  public get formControl(): FormGroupControls {
    return this.needHelpForm.controls
  }

  public showSpinner = false;

  public snackBar = inject(MatSnackBar);
  public needHelpService = inject(NeedHelpService);
  public userDetailService = inject(UserDetailService);
  public dialogRef = inject(MatDialogRef<NeedHelpComponent>);

  ngOnInit(): void {
    this.userDetailService.getUserDetails().subscribe((userDetails: UserLoggedInInfo) => {
      const userName = userDetails?.firstName + ' ' + userDetails?.lastName;
      this.needHelpForm.controls.name.setValue(userName);
    });
  }

  postNeedHelp() {
    this.showWarning = '';
    const formControl: Record<string, AbstractControl> = this.needHelpForm.controls;
    if (formControl && (formControl.email.value || formControl.phoneNumber.value)) {
      const bodyData = {
        reviewnumber: formControl.reviewNumber.value || '',
        firstname: formControl.name.value.split(' ')[0],
        lastname: formControl.name.value.split(' ').slice(1).join(' '),
        email: formControl.email.value || '',
        phone: formControl.phoneNumber.value || '',
        description: formControl.problem.value || ''
      }

      this.showSpinner = true;
      this.needHelpService.postNeedHelp({ body: bodyData })
        .subscribe((res) => {
          if (utilGet(res, 'statusCode') === 200) {
            this.showSuccessContent = true;
          } else {
            this.showWarning = res.error;
          }
        }, () => {
          this.showWarning = 'Unable to submit request';
        });
    } else {
      this.showWarning = 'Either Phone number or Email is required';
    }
  }
}
